import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import BasePage from '@ts-core/pages/BasePage';
import ResultCard from '@ts-core/core/components/ResultCard/ResultCard';

import ExercisePreviewHandler from '@ts-core/modules/exercises/components/ExercisePreviewHandler';

import { StudentAnsweredAssignment } from '../../types';

interface AssignmentAnswerProps {
  assignment?: StudentAnsweredAssignment;
  loading?: boolean;
}

const AssignmentAnswer = (props: AssignmentAnswerProps) => {
  const { assignment, loading } = props;

  if (loading) {
    return (
      <Box width="100%" textAlign="center">
        <CircularProgress />;
      </Box>
    );
  }

  return (
    <Box>
      <BasePage>
        <Box display="flex" flexDirection="row" justifyContent="center" mt={6}>
          <ResultCard score={assignment?.answer.score} maxScore={assignment?.maxScore} time={assignment?.answer.time} />
        </Box>
        {assignment?.exercises.map((exercise) => (
          <ExercisePreviewHandler
            key={exercise.id}
            exercise={exercise}
            hideScores={assignment?.showOnlyTotalScore}
            hideQuestionBackgroundColor={assignment?.showOnlyTotalScore}
          />
        ))}
      </BasePage>
    </Box>
  );
};

export default AssignmentAnswer;
